import { createRouter, createWebHistory } from 'vue-router'
import HomePage from '../components/HomePage.vue'
import GuidePage from '../views/GuidePage.vue'
import SciencePage from '../views/SciencePage.vue'
import HistoryPage from '../views/HistoryPage.vue'
import StartAssessmentPage from '../views/StartAssessmentPage.vue'
import BasicInfoPage from '../views/BasicInfoPage.vue'
import QuestionnairePage from '../views/QuestionnairePage.vue'
import CalculatingPage from '../views/CalculatingPage.vue'
import ResultPage from '../views/ResultPage.vue'
import ThemeTestPage from '../views/ThemeTestPage.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomePage
  },
  {
    path: '/guide',
    name: 'Guide',
    component: GuidePage
  },
  {
    path: '/science',
    name: 'Science',
    component: SciencePage
  },
  {
    path: '/history',
    name: 'History',
    component: HistoryPage
  },
  {
    path: '/assessment/start',
    name: 'StartAssessment',
    component: StartAssessmentPage
  },
  {
    path: '/assessment/info',
    name: 'BasicInfo',
    component: BasicInfoPage
  },
  {
    path: '/assessment/questions',
    name: 'Questionnaire',
    component: QuestionnairePage
  },
  {
    path: '/assessment/calculating',
    name: 'Calculating',
    component: CalculatingPage
  },
  {
    path: '/assessment/result',
    name: 'Result',
    component: ResultPage
  },
  {
    path: '/theme-test',
    name: 'ThemeTest',
    component: ThemeTestPage
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  }
})

export default router

